<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mt-3 mb-1 text-center">
                <div :class="{active: $route.name === 'open-buy-archive'}" class="report-category mb-2"
                     @click="onReportCategoryClicked('open-buy-archive')">
                    <h5 class="text-white">فاکتورهای بایگانی شده</h5>
                </div>
                <!--<div :class="{active: $route.name === 'open-sell-archive'}" class="report-category mb-2"-->
                     <!--@click="onReportCategoryClicked('open-sell-archive')">-->
                    <!--<h5 class="text-white">فاکتورهای باز فروش</h5>-->
                <!--</div>-->
                <div :class="{active: $route.name === 'buy-archive'}" class="report-category mb-2"
                     @click="onReportCategoryClicked('buy-archive')">
                    <h5 class="text-white">خرید</h5>
                </div>
                <div :class="{active: $route.name === 'sell-archive'}" class="report-category mb-2"
                     @click="onReportCategoryClicked('sell-archive')">
                    <h5 class="text-white">فروش</h5>
                </div>
                <!--<div :class="{active: $route.name === 'inventory-archive'}" class="report-category mb-2"-->
                     <!--@click="onReportCategoryClicked('inventory-archive')">-->
                    <!--<h5 class="text-white">موجودی</h5>-->
                <!--</div>-->
                <div :class="{active: $route.name === 'receive-archive'}" class="report-category mb-2"
                     @click="onReportCategoryClicked('receive-archive')">
                    <h5 class="text-white">دریافت</h5>
                </div>
                <div :class="{active: $route.name === 'payment-archive'}" class="report-category mb-2"
                     @click="onReportCategoryClicked('payment-archive')">
                    <h5 class="text-white">پرداخت</h5>
                </div>
                <!--<div :class="{active: $route.name === 'receive-check-archive'}" class="report-category mb-2"-->
                     <!--@click="onReportCategoryClicked('receive-check-archive')">-->
                    <!--<h5 class="text-white">چکهای دریافتی</h5>-->
                <!--</div>-->
                <!--<div :class="{active: $route.name === 'payment-check-archive'}" class="report-category mb-2"-->
                     <!--@click="onReportCategoryClicked('payment-check-archive')">-->
                    <!--<h5 class="text-white">چکهای پرداختی</h5>-->
                <!--</div>-->
            </div>
            <div class="col-lg-12 mt-2">
                <transition
                        name="fade"
                        mode="out-in"
                >
                    <router-view/>
                </transition>
            </div>
        </div>

    </div>
</template>

<script>
    import * as $ from 'jquery';
    import Vue from 'vue';

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    export default {
        name: 'archives',
        components: {},
        data() {
            return {}
        },
        methods: {
            onReportCategoryClicked(name) {
                this.$router.push({name: `${name}`});
            }
        }
    }
</script>